/* eslint-disable react/prop-types */
function InstagramIcon({ className = "", fill = "#000000", size = "24" }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 27.89 26.62" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill={fill} d="M19.29,26.62H8.6C3.86,26.62,0,22.76,0,18.02V8.6C0,3.86,3.86,0,8.6,0h10.69c4.74,0,8.6,3.86,8.6,8.6v9.42c0,4.74-3.86,8.6-8.6,8.6ZM8.6,1.91C4.91,1.91,1.91,4.91,1.91,8.6v9.42c0,3.69,3,6.69,6.69,6.69h10.69c3.69,0,6.69-3,6.69-6.69V8.6c0-3.69-3-6.69-6.69-6.69H8.6Z"/>
        <path fill={fill} d="M13.95,20.97c-4.22,0-7.66-3.44-7.66-7.66s3.43-7.66,7.66-7.66,7.66,3.43,7.66,7.66-3.43,7.66-7.66,7.66Zm0-13.4c-3.17,0-5.75,2.58-5.75,5.75s2.58,5.75,5.75,5.75,5.75-2.58,5.75-5.75-2.58-5.75-5.75-5.75Z"/>
        <path fill={fill} d="M23.07,5.89c0,.88-.71,1.59-1.59,1.59s-1.59-.71-1.59-1.59,.71-1.59,1.59-1.59,1.59,.71,1.59,1.59Z"/>
      </g>
    </svg>
  )
}

export default InstagramIcon